import { youtubeParser } from "../utils/video-playlist";

const involveMeRegex = /(?:http:\/\/)?(?:([^.]+)\.)?involve\.me/;

const GettingStarted = (app) => {
  app
    .get(
      "/getting-started/publish/:id/:option",
      async ({ api, assert, res, req, flash }) => {
        const { id, option } = req.params;
        assert(id, 400, "Workflow ID is required");
        assert(option, 400, "Option is required");

        const body = {
          id,
          option,
          value: "published",
          key: "status",
        };

        try {
          await api("workflow-option", {
            method: "PUT",
            body,
          });
          flash("success", "Successfully published");
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .get(
      "/getting-started/unpublish/:id/:option",
      async ({ api, assert, res, req, flash }) => {
        const { id, option } = req.params;
        assert(id, 400, "Workflow ID is required");
        assert(option, 400, "Option is required");

        const body = {
          id,
          option,
          value: "draft",
          key: "status",
        };

        try {
          await api("workflow-option", {
            method: "PUT",
            body,
          });
          flash("success", "Successfully unpublished");
          res.backDontScroll();
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/getting-started/video",
      async ({ api, assert, req, res, flash }) => {
        const { option, videoUrl, workflow: id, deleteVideo } = req.body;
        assert(id, 400, "Workflow ID is required");
        assert(option, 400, "Option is required");
        assert(
          videoUrl?.length || req.files?.videoFile,
          400,
          "Video is required"
        );

        const body = {
          id,
          option,
          key: "video",
        };
        if (videoUrl) {
          const isValidYoutube = youtubeParser(videoUrl);
          assert(isValidYoutube, 400, "You must provide a valid YouTube video");
          body.value = videoUrl;
        }
        if (deleteVideo) body.deleteVideo = deleteVideo;

        try {
          await api("workflow-option", {
            method: "PUT",
            body,
            files: req.files,
          });
          flash("success", "Successfully added video");
          if (option === "welcomeVideo") {
            res.refreshWith(
              {
                "modal[type]": "",
              },
              { url: "back", hash: "#_" }
            );
          } else {
            res.refreshWith(
              {
                explanationAdded: "true",
              },
              { url: "back", hash: "#_" }
            );
          }
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/getting-started/link-program",
      async ({ api, assert, req, res, flash }) => {
        const { option, url, workflow: id } = req.body;
        assert(id, 400, "Workflow ID is required");
        assert(option, 400, "Option is required");
        assert(
          url && involveMeRegex.test(url),
          400,
          "A valid involve.me URL is required"
        );

        const body = {
          id,
          option,
          key: "url",
          value: url,
        };

        try {
          await api("workflow-option", {
            method: "PUT",
            body,
          });
          flash("success", "Successfully linked program");
          res.refreshWith(
            {
              "modal[type]": "",
              explanationAdded: "",
            },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/getting-started/integrations",
      async ({ api, assert, req, res, flash }) => {
        const { option, workflow: id } = req.body;
        assert(id, 400, "Workflow ID is required");
        assert(option, 400, "Option is required");

        const items = Object.keys(req.body).filter(
          (key) => req.body[key] === true
        );

        const body = {
          id,
          option,
          value: items.length > 0 ? items : "empty",
          key: "items",
        };

        try {
          await api("workflow-option", {
            method: "PUT",
            body,
          });
          flash("success", "Successfully saved");
          res.refreshWith(
            {
              "modal[type]": "",
            },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/getting-started/select-macro-calculator",
      async ({ api, assert, req, res, flash }) => {
        const { option, workflow: id, value } = req.body;
        assert(id, 400, "Workflow ID is required");
        assert(option, 400, "Option is required");
        assert(value, 400, "Macro calculator is required");

        const body = {
          id,
          option,
          value,
          key: "widget",
        };

        try {
          await api("workflow-option", {
            method: "PUT",
            body,
          });
          flash("success", "Successfully saved");
          res.refreshWith(
            {
              "modal[type]": "",
            },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/getting-started/select-video-playlist",
      async ({ api, assert, req, res, flash }) => {
        const { option, workflow: id, value } = req.body;
        assert(id, 400, "Workflow ID is required");
        assert(option, 400, "Option is required");
        assert(value, 400, "Video playlist is required");

        const body = {
          id,
          option,
          value,
          key: "playlist",
        };

        try {
          await api("workflow-option", {
            method: "PUT",
            body,
          });
          flash("success", "Successfully saved");
          res.refreshWith(
            {
              "modal[type]": "",
            },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/getting-started/select-guides",
      async ({ api, assert, req, res, flash }) => {
        const { option, workflow: id, value } = req.body;
        assert(id, 400, "Workflow ID is required");
        assert(option, 400, "Option is required");
        assert(value, 400, "Guide is required");

        const body = {
          id,
          option,
          value,
          key: "widget",
        };

        try {
          await api("workflow-option", {
            method: "PUT",
            body,
          });
          flash("success", "Successfully saved");
          res.refreshWith(
            {
              "modal[type]": "",
            },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/getting-started/select-meal-plan-library",
      async ({ api, assert, req, res, flash }) => {
        const { option, workflow: id, value } = req.body;
        assert(id, 400, "Workflow ID is required");
        assert(option, 400, "Option is required");
        assert(value, 400, "Meal plan library is required");

        const body = {
          id,
          option,
          value,
          key: "widget",
        };

        try {
          await api("workflow-option", {
            method: "PUT",
            body,
          });
          flash("success", "Successfully saved");
          res.refreshWith(
            {
              "modal[type]": "",
            },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/getting-started/select-daily-accountability-templates",
      async ({ api, assert, req, res, flash }) => {
        const { option, workflow: id, value } = req.body;
        assert(id, 400, "Workflow ID is required");
        assert(option, 400, "Option is required");
        assert(value, 400, "Daily accountability templates is required");

        const body = {
          id,
          option,
          value,
          key: "widget",
        };

        try {
          await api("workflow-option", {
            method: "PUT",
            body,
          });
          flash("success", "Successfully saved");
          res.refreshWith(
            {
              "modal[type]": "",
            },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/getting-started/add-contract",
      async ({ api, assert, req, res, flash }) => {
        const { option, contract, workflow: id } = req.body;
        assert(id, 400, "Workflow ID is required");
        assert(option, 400, "Option is required");
        assert(contract, 400, "Contract is required");

        const body = {
          id,
          option,
          key: "contract",
          value: contract,
        };

        try {
          await api("workflow-option", {
            method: "PUT",
            body,
          });
          flash("success", "Successfully added contract");
          res.refreshWith(
            {
              "modal[type]": "",
              explanationAdded: "",
            },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    )
    .post(
      "/getting-started/questionnaire",
      async ({ api, assert, req, res, flash }) => {
        const { option, workflow: id, value } = req.body;
        assert(id, 400, "Workflow ID is required");
        assert(option, 400, "Option is required");

        const body = {
          id,
          option,
          value,
          key: "questions",
        };

        console.log(body);

        try {
          await api("workflow-option", {
            method: "PUT",
            body,
          });
          flash("success", "Successfully saved");
          res.refreshWith(
            {
              "modal[type]": "",
            },
            { url: "back", hash: "#_" }
          );
        } catch (e) {
          flash("error", e.message);
          res.backDontScroll();
        }
      }
    );
};

export default GettingStarted;
